<div class="flex flex-col configuration-wrapper">
  <div class="flex flex-row flex-1 overflow-hidden">
    <div class="datapoint-nav-container">
      <div class="title">
        <mat-icon class="material-symbols-rounded">edit_document</mat-icon>
        <h3 class="product-heading-bold">Categories</h3>
      </div>

      <ul>
        <ng-container *ngFor="let category of scenario?.categories; trackBy: trackById">
          <li
            *ngIf="!isCategoryExcluded(category)"
            class="data-tab-nodes"
            [ngClass]="{
              active: category.id === selectedCategoryId,
              disabled: editable && !categoryStates[category.id]?.enabled,
            }"
            (click)="selectCategory(category.id)">
            <span
              class="flex-1 overflow-ellipsis-two-rows"
              isEllipsisActive>
              {{ category.name }}
            </span>

            <ng-container *ngIf="categoryStates[category.id]?.completed">
              <mat-icon
                *ngIf="isDeliverableExcludedInCategory(category)"
                class="material-symbols-rounded warning"
                isEllipsisActive="This category has items which will be deleted from the scope/configuration after form is submitted">
                warning
              </mat-icon>
              <mat-icon
                *ngIf="!categoryStates[category.id]?.errorCount"
                class="material-symbols-rounded completed">
                check
              </mat-icon>
              <span
                *ngIf="categoryStates[category.id]?.errorCount"
                class="error">
                {{ categoryStates[category.id]?.errorCount }}
              </span>
            </ng-container>
            <mat-icon
              *ngIf="!editable || categoryStates[category.id]?.enabled"
              class="material-symbols-rounded orange">
              chevron_right
            </mat-icon>
          </li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngFor="let category of scenario?.categories; trackBy: trackById">
      <div
        class="datapoint-content-container"
        *ngIf="category.id === selectedCategoryId">
        <div class="datapoint-content-container-inner">
          <h2 class="product-heading-bold">{{ category.name }}</h2>
          <div class="wrapper">
            <ng-container *ngFor="let question of category.questions; trackBy: trackById; index as i">
              <ng-container *ngIf="isQuestionShown(question)">
                <div
                  class="question"
                  [class.darken]="!(i % 2)"
                  [class.excluded]="isDeliverableExcluded(question)">
                  <span>{{ getDisplayText(question) }}</span>
                  <span
                    *ngIf="question.mandatory"
                    class="scope-input-required">
                  </span>
                </div>

                <div
                  class="question__inputs"
                  [class.darken]="!(i % 2)">
                  <scope-ui-input
                    id="{{ question.id }}"
                    *ngIf="question.type === QuestionType.TEXT"
                    [type]="'text'"
                    class="form-group pb-8 w-full"
                    [initialValue]="question.value"
                    [isTextarea]="true"
                    [isDisabled]="!editable"
                    [control]="questionStates[question.id].control"
                    [textareaRows]="1"
                    [inputPlaceholder]="question.fieldLabel"
                    [formSubmitted]="formSubmitted"
                    [autoExpand]="true"
                    [maximumLength]="question.maxLength || 9999"
                    (onInputBlurChange)="setAnswer(question, $event)" />
                  <scope-ui-input
                    id="{{ question.fieldId }}"
                    *ngIf="question.type === QuestionType.NUMBER"
                    [type]="'number'"
                    class="form-group pb-8 w-full"
                    [inputPlaceholder]="question.fieldLabel"
                    [isDisabled]="!editable"
                    [initialValue]="question.value"
                    [noArrows]="true"
                    [control]="questionStates[question.id].control"
                    [formSubmitted]="formSubmitted"
                    [isInteger]="question.wholeNumber"
                    [minimum]="question.minimum"
                    [maximum]="question.maximum"
                    (onInputBlurChange)="setAnswer(question, $event)" />
                  <scope-ui-input
                    id="{{ question.fieldId }}"
                    *ngIf="question.type === QuestionType.FEE && !question.feePrompt"
                    [type]="'number'"
                    class="form-group pb-8 w-full"
                    [inputPlaceholder]="feePlaceHolder"
                    [isDisabled]="!editable"
                    [initialValue]="question.feeValue"
                    [noArrows]="true"
                    [control]="questionStates[question.id].feeControl"
                    [formSubmitted]="formSubmitted"
                    [isInteger]="question.wholeNumber"
                    [minimum]="question.minimum || 0"
                    [maximum]="question.maximum || 999"
                    (onInputBlurChange)="setFeeAnswer(question, $event)" />
                  <scope-ui-datepicker
                    id="{{ question.id }}"
                    *ngIf="question.type === QuestionType.DATE"
                    [singleDatePicker]="true"
                    [inputPlaceholder]="question.fieldLabel"
                    [initialValue]="question.value"
                    [disabled]="!editable"
                    [formSubmitted]="formSubmitted"
                    [dateControl]="questionStates[question.id].control"
                    [minDate]="question.minDate"
                    [maxDate]="question.maxDate"
                    (onSelect)="setAnswer(question, $event)" />
                  <scope-ui-dropdown
                    id="{{ question.id }}"
                    *ngIf="question.type === QuestionType.DROPDOWN"
                    [selectedValue]="question.value"
                    [isStandardDropdown]="true"
                    [disabled]="!editable"
                    [formSubmitted]="formSubmitted"
                    [selectControl]="questionStates[question.id].control"
                    [inputPlaceholder]="question.fieldLabel"
                    [dropdownOptions]="question.optionsList.split(',')"
                    (onSelectionChange)="setAnswer(question, $event)" />

                  <div
                    *ngIf="question.type === QuestionType.DELIVERABLE || isFeeWithDeliverables(question)"
                    id="{{ question.id }}"
                    class="dropdown-container"
                    #dropdownContainer
                    [class.excluded]="isDeliverableExcluded(question)">
                    <div
                      class="pinned-deliverables"
                      [class.pinned-deliverables--disabled]="!editable">
                      <div class="pinned-items">
                        <ng-container *ngFor="let deliverable of getDeliverablePromptOptions(question)">
                          <div
                            *ngIf="deliverableMap[deliverable.deliverableId] as deliverableEntryDetails"
                            class="pinned-deliverable"
                            [ngClass]="{
                              added: deliverable.added && !isDeliverableExcluded(question),
                              deleted: deliverable.deleted || isDeliverableExcluded(question),
                            }">
                            {{ getDeliverableName(deliverableEntryDetails) }}
                            <ng-container *ngIf="editable && !isDeliverableExcluded(question)">
                              <mat-icon
                                *ngIf="!deliverable.required && !deliverable.deleted"
                                class="material-symbols-rounded center pointer"
                                (click)="unselectDeliverable(deliverable, question)">
                                close
                              </mat-icon>
                              <mat-icon
                                *ngIf="deliverable.deleted"
                                class="material-symbols-rounded center pointer"
                                (click)="selectDeliverable(deliverable, question)">
                                undo
                              </mat-icon>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>

                      <mat-icon
                        *ngIf="isDeliverableToggleAvailable(question)"
                        class="material-symbols-rounded orange pointer"
                        (click)="toggleDropdown(question.id)">
                        {{ isDropdownOpen.get(question.id) ? 'close' : 'add' }}
                      </mat-icon>
                    </div>
                    <div
                      *ngIf="isDropdownOpen.get(question.id)"
                      class="dropdown-menu"
                      [style.width.px]="dropdownContainer.offsetWidth">
                      <ng-container
                        *ngFor="
                          let deliverable of questionStates[question.id].deliverablePromptOptions;
                          trackBy: trackByDeliverableId
                        ">
                        <div
                          class="dropdown-item"
                          *ngIf="deliverableMap[deliverable.deliverableId] as deliverableEntryDetails"
                          (click)="toggleDeliverableSelection(!deliverable.selected, deliverable, question)">
                          <span
                            class="dropdown-item-label"
                            [ngClass]="{ bold: deliverable.selected }">
                            {{ getDeliverableName(deliverableEntryDetails) }}
                          </span>
                          <span class="dropdown-item-icon">
                            <mat-icon
                              *ngIf="deliverable.selected"
                              class="material-symbols-rounded">
                              check
                            </mat-icon>
                          </span>
                        </div>
                      </ng-container>
                    </div>
                    <mat-error
                      *ngIf="formSubmitted && question.mandatory && questionStates[question.id].control?.invalid">
                      At least one deliverable must be selected.
                    </mat-error>
                  </div>

                  <div
                    *ngIf="question.type === QuestionType.FEE && question.feePrompt"
                    id="{{ question.id }}"
                    class="dropdown-container"
                    #feeDropdownContainer>
                    <div
                      class="pinned-deliverables"
                      [class.pinned-deliverables--disabled]="!editable">
                      <div class="pinned-items">
                        <span *ngFor="let fee of questionStates[question.id].feePromptOptions">
                          <div
                            *ngIf="fee.selected"
                            class="pinned-deliverable">
                            {{ fee.name }}
                            <mat-icon
                              *ngIf="editable && !fee.required"
                              class="material-symbols-rounded center pointer"
                              (click)="unselectFee(fee, question)">
                              close
                            </mat-icon>
                          </div>
                        </span>
                      </div>
                      <mat-icon
                        *ngIf="isFeeToggleAvailable(question)"
                        class="material-symbols-rounded orange pointer"
                        (click)="toggleFeeDropdown(question.id)">
                        {{ isFeeDropdownOpen.get(question.id) ? 'close' : 'add' }}
                      </mat-icon>
                    </div>
                    <div
                      *ngIf="isFeeDropdownOpen.get(question.id)"
                      class="dropdown-menu"
                      [style.width.px]="feeDropdownContainer.offsetWidth">
                      <div
                        *ngFor="let fee of questionStates[question.id].feePromptOptions; trackBy: trackByFeeId"
                        class="dropdown-item"
                        (click)="selectFee(fee, question)">
                        <span
                          class="dropdown-item-label"
                          [ngClass]="{ bold: fee.selected }">
                          {{ fee.name }}
                        </span>
                        <span class="dropdown-item-icon">
                          <mat-icon
                            *ngIf="fee.selected"
                            class="material-symbols-rounded">
                            check
                          </mat-icon>
                        </span>
                      </div>
                    </div>
                    <mat-error
                      *ngIf="formSubmitted && question.mandatory && questionStates[question.id].feeControl?.invalid">
                      At least one fee must be selected.
                    </mat-error>
                  </div>

                  <div
                    class="formula-container"
                    *ngIf="question.type === QuestionType.FORMULA">
                    <span
                      *ngIf="questionStates[question.id]?.calcError"
                      class="result text-error-600">
                      <ng-container *ngIf="questionStates[question.id]?.errorMessage; else defaultErrorMessage">
                        {{ questionStates[question.id]?.errorMessage }}
                      </ng-container>
                      <ng-template #defaultErrorMessage>
                        Value cannot be calculated. Please contact your administrator.
                      </ng-template>
                    </span>
                    <span
                      *ngIf="!questionStates[question.id]?.calcError"
                      class="result">
                      {{ configuration[category.id]?.[question.id] }}
                    </span>
                    <button
                      class="orange text-link small"
                      (click)="showFormulaMap[question.id] = !showFormulaMap[question.id]">
                      {{ showFormulaMap[question.id] ? 'Hide Formula' : 'View Formula' }}
                    </button>
                  </div>

                  <formula-builder
                    *ngIf="question.type === QuestionType.FORMULA"
                    id="{{ question.id }}"
                    class="w-full col-span-2"
                    [hidden]="!showFormulaMap[question.id]"
                    [scenario]="scenario"
                    [showInput]="false"
                    [showFormula]="showFormulaMap[question.id]"
                    [(value)]="question.formula" />

                  <div
                    *ngIf="question.type !== QuestionType.FORMULA"
                    class="w-full col-span-2"
                    [hidden]="true"></div>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <ng-container
            *ngIf="!(saveLoading$ | async) && !(loadingModifiers$ | async) && !(submitLoading$ | async) && editable">
            <button
              *ngIf="isSaveAvailable(category.id)"
              mat-flat-button
              class="action-button"
              [disabled]="isSaveDisabled(category.id)"
              (click)="save(category)">
              Save answers
            </button>

            <ng-container *ngIf="!categoryStates[category.id]?.updated">
              <ng-template
                #nextButton
                let-nextCategoryId="nextCategoryId">
                <button
                  *ngIf="nextCategoryId && !categoryStates[nextCategoryId]?.enabled"
                  mat-flat-button
                  class="action-button"
                  (click)="save(category, true)"
                  [disabled]="!editable">
                  Next Category
                </button>
                <button
                  *ngIf="nextCategoryId && categoryStates[nextCategoryId]?.enabled"
                  mat-flat-button
                  class="action-button"
                  (click)="selectCategory(nextCategoryId)"
                  [disabled]="!editable">
                  Next Category
                </button>
                <ng-container *ngIf="isSubmitAvailable(nextCategoryId)">
                  <scope-ui-checkbox
                    *ngIf="isEditDeliverablePromptAgreeRequired(nextCategoryId)"
                    [ngModel]="editDeliverablePromptAgree"
                    (ngModelChange)="editDeliverablePromptAgree = $event"
                    title="I understand that items highlighted in red will be deleted from the scope/configuration" />
                  <scope-ui-checkbox
                    *ngIf="isEditChangeRequestByScenarioAgreeRequired(nextCategoryId)"
                    [ngModel]="editChangeRequestByScenarioAgree"
                    (ngModelChange)="editChangeRequestByScenarioAgree = $event"
                    title="I understand that by submitting changes to CR by scenario form will override any manual changes I have done to this CR so far" />
                  <button
                    mat-flat-button
                    class="action-button"
                    (click)="submitConfiguration()"
                    [disabled]="isSubmitDisabled(nextCategoryId)">
                    Submit Form
                  </button>
                </ng-container>
              </ng-template>
              <ng-container
                *ngTemplateOutlet="
                  nextButton;
                  context: { nextCategoryId: getNextCategoryId(category.id) }
                "></ng-container>
            </ng-container>
          </ng-container>
          <button
            mat-flat-button
            class="action-button active"
            *ngIf="(saveLoading$ | async) || (loadingModifiers$ | async) || (submitLoading$ | async)">
            <img
              ngSrc="/assets/icons/loading.svg"
              alt="loading"
              class="icon-spinner"
              height="25"
              width="24" />
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
